// extracted by mini-css-extract-plugin
module.exports = {"trailer":"B4","imgWrapper":"B5","thumbnail":"B6","isRental":"B7","playWrapper":"B8","playImg":"B9","title":"B-","iconWrapper":"B_","icon":"Ca"};